<div class="hover-holder">
	<div [id]="'more-info'" class="info-icon">
		<span (click)="toggleMsg = !toggleMsg" (keyup)="clickToggle($event)" role="button" attr.aria-expanded="{{ toggleMsg }}" attr.aria-label="{{ 'general.more.info' | translate }}">
			<i class="fa fa-question-circle" aria-hidden="true"></i>
			<div class="hover-msg" [ngClass]="{ 'display-block': toggleMsg }" *ngIf="toggleMsg">
				<div class="hover-msg-inner">
					{{ text | translate }}
				</div>
			</div>
		</span>
	</div>
</div>
